import { initializeApp } from 'firebase/app'
import {
  getMessaging,
  getToken,
  isSupported,
  onMessage,
} from 'firebase/messaging'
import { constants } from '../constants'

const firebaseConfig = {
  apiKey: constants.MESSAGING_API_KEY,
  authDomain: constants.MESSAGING_AUTH_DOMAIN,
  projectId: constants.MESSAGING_PROJECT_ID,
  storageBucket: constants.MESSAGING_STORAGE_BUCKET,
  messagingSenderId: constants.MESSAGING_SENDER_ID,
  appId: constants.MESSAGING_APP_ID,
}

const FIREBASE_VAPID_KEY = constants.MESSAGING_VAPID_KEY

const app = initializeApp(firebaseConfig)
const messagingAsync = (async () => {
  try {
    const isSupportedBrowser = await isSupported()
    if (isSupportedBrowser) {
      console.log('Firebase is supported on this browser')
      return typeof window !== 'undefined' ? getMessaging(app) : null
    }
    console.log('Firebase is not supported in this browser')
  } catch (err) {
    console.log(err)
  }
  return null
})()

const onMessageListener = () => {
  return new Promise((resolve) => {
    messagingAsync.then((messaging) => {
      console.log('START mESSAGe 567', messaging)
      return onMessage(messaging, ({ data }) => {
        console.log(data, 'foreground message................')
        resolve(data)
      })
    })
  })
}

const getOrRegisterServiceWorker = () => {
  if (
    'serviceWorker' in navigator &&
    typeof window.navigator.serviceWorker !== 'undefined'
  ) {
    return window.navigator.serviceWorker
      .getRegistration('/firebase-cloud-messaging-push-scope')
      .then((serviceWorker) => {
        if (serviceWorker) return serviceWorker // if already registered
        // register
        return window.navigator.serviceWorker
          .register('/firebase-messaging-sw.js', {
            scope: '/firebase-push-notification-scope',
          })
          .then((serviceWorker) => {
            console.log('success registering SW')
            return serviceWorker
          })
          .catch((err) => {
            console.log('registering failed', err)
          })
      })
  }
}

const requestToken = async () => {
  let currentToken = ''
  try {
    const messaging = await messagingAsync
    const serviceWorkerRegistration = await getOrRegisterServiceWorker()
    console.log(messaging, serviceWorkerRegistration, 'requestToken')
    currentToken = await getToken(messaging, {
      vapidKey: FIREBASE_VAPID_KEY,
      serviceWorkerRegistration,
    })
    if (!currentToken || currentToken == '') {
      console.log(
        'No registration token available. Request permission to generate one.'
      )
    }
  } catch (error) {
    console.log('An error occurred while retrieving token. ', error)
  }
  return currentToken
}

export { requestToken, onMessageListener }
